export default __webpack_public_path__ + "static/media/sleep.e184387d.png";